import { create } from "zustand";

type User = {
  id: string;
  userId: string;
  isPrimary: string;
  name: string;
  age: string;
  mobile: string;
  phoneCode: string;
  email: string;
  birthDate: string;
  bloodGroup: string;
  gender: string;
  jerseySize: string;
  distance: string;
  profileImage: string;
  status: "UNVERIFIED" | "VERIFIED";
  categoryId?: string;
  price?: number;
};

type Store = {
  selectedUsers: User[];
  addSelectedUser: (user: User) => void;
  removeSelectedUser: (id: string) => void;
  updateSelectedUser: (users: User[]) => void;
  updateUser: (id: string, updatedData: Partial<User>) => void;
};

export const useMarathonCartStore = create<Store>((set) => ({
  selectedUsers: [] as User[],

  addSelectedUser: (user) =>
    set((state) => ({
      selectedUsers: [...state.selectedUsers, user],
    })),

  removeSelectedUser: (id) =>
    set((state) => ({
      selectedUsers: state.selectedUsers.filter(
        (selectedUser) => selectedUser.id !== id
      ),
    })),
  updateSelectedUser: (users) => set({ selectedUsers: users }),
  updateUser: (id: string, updatedData: Partial<User>): void =>
    set((state) => ({
      selectedUsers: state.selectedUsers.map((user) =>
        user.id === id ? { ...user, ...updatedData } : user
      ),
    })),
}));

